<template>
  <!-- Use hide-details to avoid scroll-y of header!!!! -->
  <div class="d-flex align-center">
    <icon-text-btn
      @onClick="onOpen"
      :icon="'mdi-file-table-box-outline'"
      :text="'Umlauf wählen'"
      :iconColor="theme.appBar.other.color"
      :small="small"
      :noWrap="noWrap"
    ></icon-text-btn>

    <v-dialog
      v-model="isOpen"
      style="display: flex; flex-direction: column; flex: 1"
      :fullscreen="smAndDown"
      :max-width="mdAndUp ? '1000px' : ''"
      class="font-size"
    >
      <div v-if="isOpen" class="background" :style="{ height: mdAndUp ? '80vh' : '100vh' }" style="display: flex; flex-direction: column">
        <div class="op-toolbar px-3 py-2" style="border-bottom: 1px solid #d0d0d0; display: flex; justify-content: flex-end; align-items: center">
          <div class="font-weight-bold" style="display: flex; flex: 1">{{ $t('linieKursUmlaufSelektion') }}</div>
          <v-btn icon @click="isOpen = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="pt-3 px-3" style="display: flex; justify-content: flex-start; gap: 10px; align-items: center; flex-wrap: wrap">
          <date-list-picker
            style="display: flex"
            :color="color"
            v-model="selectedDateIndex"
            v-if="datesIsoStrings.length"
            :availableDateIsoStringsSorted="datesIsoStrings"
            @onDateSelected="onDateSelected"
          ></date-list-picker>

          <v-btn color="primary" @click="selectToday">{{ $t('today') }}</v-btn>

          <v-text-field
            class="ml-8"
            hide-details
            filled
            rounded
            style="display: flex; max-width: 300px; user-select: all !important"
            color="primary"
            :label="$t('filter')"
            :placeholder="$t('typeToFilter')"
            autofocus
            v-model="filter"
            clearable
          ></v-text-field>

          <v-checkbox class="ml-2" v-model="showDetails" label="Details anzeigen"></v-checkbox>
        </div>
        <div class="px-3" :style="``">
          <!--          <div class="text-h5 text-no-wrap py-3">{{ selectedDate }}</div>-->
          <div style="display: flex" class="pt-3">
            <div class="text-h6 pl-2" style="width: 100px !important">{{ $t('fd452.lines') }}</div>
            <!--            <div class="text-h6 pl-2" style="flex: 1">{{ $t('track') }}</div>-->
            <div class="text-h6 pl-4 flex-start" style="flex: 1">Kurs / Umlauf</div>
            <!--            <div class="text-h6" style="width:100px">{{ $t('umlauefe') }}</div>-->
          </div>
        </div>
        <div class="px-3" :style="`flex:1;overflow-y:scroll;font-size:${$store.state.profile.userProfile.baseFontSize}px`">
          <div style="display: flex" class="item-bottom-border" v-for="(line, index) in currentLines" :key="index">
            <div class="line cell column text-no-wrap" style="width: 100px" v-html="cellValue(line.linienKuerzel)"></div>
            <div class="d-flex justify-start full-width flex-wrap">
              <div class="d-flex mx-3" v-for="umlauf in Object.keys(line.kursAndUmlauf)" :key="index + '_' + umlauf">
                <div
                  class="cell text-no-wrap px-1"
                  v-ripple
                  @click.stop="onUmlaufSelected({ lineItem: line, tourHash: line.kursAndUmlauf[umlauf].tourHash })"
                  v-html="chipContent(line, umlauf)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import common from '@/mixins/common';
import DateListPicker from '@/components/pickers/DateListPicker';
import dateUtils from '../../common/dateUtils';
import IconTextBtn from '@/components/buttons/IconTextBtn.vue';
import storeNonReactive from './storeNonReactive';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import configMixin from '@/mixins/configMixin';
import umlaufLinieKursSearchService from '@/modules/fahrdienst452/umlaufLinieKursSearchService';

export default {
  name: 'UmlaufLinieKursSearch',
  mixins: [common, configMixin, dateTimeMixin],
  props: {
    dateYYYYMMDD: String,
    value: { type: Object, default: () => {} },
    color: { type: String, default: '' },
    text: String /* Optional display text */,
    small: { type: Boolean, default: true },
    noWrap: { type: Boolean, default: false },
  },
  components: {
    DateListPicker,
    IconTextBtn,
  },
  data() {
    return {
      isOpen: false,
      selectedDateIndex: 0,
      filter: null,
      showDetails: false,
    };
  },
  mounted() {
    if (this.isOpen) {
      this.selectedDateIndex = this.getSelectedDateIndex_(this.dateYYYYMMDD);
    }
  },

  computed: {
    normalizedFilter() {
      if (typeof this.filter !== 'string' || !this.filter) {
        return this.filter || '';
      }
      const trimmed = this.filter.trim();
      if (/^\d+$/.test(trimmed)) {
        return trimmed.replace(/^0+/, '') || '0';
      }
      return trimmed;
    },
    lowercasedFilter() {
      return this.normalizedFilter ? this.normalizedFilter.toLowerCase() : this.filter;
    },
    /**
     * Available dates with umlauf data
     * @returns {*}
     */
    datesIsoStrings() {
      const availableDays = {};
      storeNonReactive.timetable.forEach((item) => (availableDays[item.day] = true));
      // console.debug('availableDays', JSON.stringify(availableDays, null, 2));
      return Object.keys(availableDays);
    },
    kursUmlauefeByLineKuerzelAtSelectedDate() {
      let currentDayTimetableItems = storeNonReactive.timetable.filter((item) => {
        // console.debug(`find item.day===selectedDateIsoString: ${item.day}==?${this.selectedDateIsoString}`)
        return item.day === this.selectedDateIsoString;
      });
      return umlaufLinieKursSearchService.createKursUmlauefeByLineKuerzel(currentDayTimetableItems);
    },

    currentLines() {
      let kursUmlauefeByLineKuerzel = this.kursUmlauefeByLineKuerzelAtSelectedDate;

      return Object.keys(kursUmlauefeByLineKuerzel)

        .filter((linienKuerzel) => {
          if (linienKuerzel == 'null') {
            return false;
          }
          let item = kursUmlauefeByLineKuerzel[linienKuerzel];
          if (item && this.normalizedFilter) {
            let kurseStr = Object.keys(item.kursAndUmlauf)
              .map((umlauf) => item.kursAndUmlauf[umlauf].kurs)
              .join('Kurs ');
            let umlaufNumbers = Object.keys(item.kursAndUmlauf).join(' ');
            let concatenated = `Linie ${item.linienKuerzel} ${kurseStr} ${umlaufNumbers}`.toLowerCase();
            return concatenated.indexOf(this.lowercasedFilter) >= 0;
          }
          return true;
        })

        .sort((lineKuerzelA, lineKuerzelB) => {
          if (isNaN(lineKuerzelA) || isNaN(lineKuerzelB)) {
            return lineKuerzelA.localeCompare(lineKuerzelB);
          }
          return Number(lineKuerzelA) - Number(lineKuerzelB);
        })

        .map((linienKuerzel) => kursUmlauefeByLineKuerzel[linienKuerzel]);
    },

    selectedDateIsoString() {
      return this.datesIsoStrings[this.selectedDateIndex];
    },
    selectedDateTime() {
      return this.selectedDateIsoString ? Date.parse(this.selectedDateIsoString) : null;
    },
    selectedDate() {
      return dateUtils.formatAsLocaleNamedShortDate(new Date(this.selectedDateTime));
    },
    selectedDateAsYYYYMMDD() {
      if (this.selectedDateIsoString) {
        return dateUtils.formatDateAsYYYYMMDD(new Date(Date.parse(this.selectedDateIsoString) + 60 * 60 * 1000));
      }
      return null;
    },
  },
  methods: {
    /**
     * Returns umlauefe of the given line. Returns an object with the linienKuerzel and a kursAndUmlauf object containing Umlauf objects mapped by linienKuerzel
     * @param kursUmlauefeByLineKuerzel - Kurs umlauf map by lineKuerzel
     * @param linienKuerzel - the linienKuerzel
     * @returns {{linienKuerzel:String, kursAndUmlauf: {}}}
     */
    getUmlauefeOfLinienKuerzel(kursUmlauefeByLineKuerzel, linienKuerzel) {
      let kursUmlauefe = kursUmlauefeByLineKuerzel[linienKuerzel];

      if (!kursUmlauefe) {
        kursUmlauefe = { kursAndUmlauf: {}, linienKuerzel: null };
        kursUmlauefeByLineKuerzel[linienKuerzel] = kursUmlauefe;
      }
      kursUmlauefe.linienKuerzel = linienKuerzel;
      return kursUmlauefe;
    },
    chipContent(line, umlauf) {
      let kursAndUmlauf = line.kursAndUmlauf[umlauf];
      let kursLabel = `Kurs${kursAndUmlauf.kurse.length > 1 ? 'e' : ''}`;
      let kurse = kursAndUmlauf.kurse.join(', ');
      let details = this.showDetails ? `&nbsp;${kursAndUmlauf.fromTo}` : '';
      return this.cellValue(`${kursLabel} ${kurse} &nbsp;/&nbsp;Umlauf&nbsp;<b>${umlauf}</b>${details}`);
    },
    getSelectedDateIndex_(dateYYYYMMDD) {
      if (!dateYYYYMMDD) return 0;
      let dateFrag = dateYYYYMMDD.split('-');
      let date = new Date(dateFrag[0], Number(dateFrag[1]) - 1, dateFrag[2]).getTime();
      const threshold = 3 * 60 * 60 * 1000;
      let upperLimit = date + threshold;
      let lowerLimit = date - threshold;
      let selectedDateIndex = this.datesIsoStrings.findIndex((iso) => {
        let dateFromIsoStr = Date.parse(iso);
        return lowerLimit < dateFromIsoStr && upperLimit > dateFromIsoStr;
      });
      // console.debug('getSelectedDateIndex_', dateYYYYMMDD, selectedDateIndex);
      if (!selectedDateIndex || selectedDateIndex < 0) {
        selectedDateIndex = 0;
      }
      return selectedDateIndex;
    },
    getSelectedDateIndex(value) {
      if (value.value && !!value.value.day) {
        let d = value.value.day;

        let search = new Date(Date.parse(d.substring(0, 10)));
        let year = search.getFullYear();
        let month = `0${search.getMonth() + 1}`.slice(-2);
        let day = `0${search.getDate()}`.slice(-2);
        let searchStr = `${year}-${month}-${day}`;
        console.debug('getSelectedDateIndex value.value.day', value.value.day, 'search', search.toISOString(), JSON.stringify(this.datesIsoStrings, null, 2));

        let selectedDateIndex = this.datesIsoStrings.findIndex((iso) => iso.includes(d));
        if (!selectedDateIndex || selectedDateIndex < 0) {
          return 0;
        }
        return selectedDateIndex;
      }
      return 0;
    },
    onOpen() {
      console.debug('UmlaufLinieKursSearch clicked');
      this.isOpen = true;
      if (!this.selectedDateIndex) {
        this.$nextTick(() => {
          console.debug('selectToday');
          this.selectToday();
        });
      }
    },
    getColor(track) {
      if (this.dataValue && this.dataValue.value) {
        return this.dataValue.value.track == track ? 'red' : '';
      }
      return null;
    },
    onDateSelected(selectedDateIndex) {
      this.selectedDateIndex = selectedDateIndex;
    },

    onUmlaufSelected({ lineItem, tourHash }) {
      this.$emit('onUmlaufSelected', { yyyymmdd: this.selectedDateAsYYYYMMDD, tourHash });
      this.isOpen = false;
    },
    selectToday() {
      let now = new Date(Date.now());
      let index = this.datesIsoStrings.findIndex((dateIsoString) => dateUtils.isSameDate(now, dateUtils.parseISOString(dateIsoString)));
      if (index >= 0) {
        this.selectedDateIndex = index;
      }
    },

    cellValue(value) {
      let valueStr = `${value}`;
      let ind = valueStr.indexOf(this.normalizedFilter);
      if (valueStr && this.normalizedFilter && ind >= 0) {
        return `<span>${valueStr.substring(0, ind)}</span><span style="color:red">${this.normalizedFilter}</span>${valueStr.substring(
          ind + this.normalizedFilter.length
        )}`;
      }
      return valueStr;
    },
  },

  watch: {
    dateYYYYMMDD(newValue, oldValue) {
      console.debug('UmlaufLinieKursSearch received new date', newValue);
      if (newValue !== oldValue) {
        this.selectedDateIndex = this.getSelectedDateIndex_(newValue);
      }
    },

    dataValue(newValue, oldValue) {
      this.$emit('input', newValue);
    },

    isOpen(newValue, oldValue) {
      if (newValue) {
        this.selectedDateIndex = this.getSelectedDateIndex_(this.dateYYYYMMDD);
        console.debug('isOpen', newValue, 'this.selectedDateIndex', this.dateYYYYMMDD, this.selectedDateIndex);
        //this.filter = null;
      }
    },
  },
};
</script>
<style scoped>
.column {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  padding: 0 10px;
}

.font-size {
  font-size: 1.4em !important;
}

.line {
  display: flex;
  text-align: left;
  align-items: center;
  font-weight: 800;
}

.cell {
  border-radius: 8px;
  margin: 5px;
  padding: 4px;
  min-width: 40px;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
}

.theme--light .cell {
  background: #e0e0e0;
}

.theme--dark .cell {
  background: #303030;
}
</style>
